














































































import {
  defineComponent,
  useContext,
  ref,
  reactive,
} from '@nuxtjs/composition-api'
import { FormRef } from '../base/Form.vue'
import { CustomRules } from '~/composables/ui/useValidations'
import { useLoading } from '~/composables/ui/useLoading'

export default defineComponent({
  name: 'BlocksNewsletter',
  inheritAttrs: false,
  
  setup() {
    const emailCorrect = ref(true)
    const isSubmitFail = ref(false)
    const submitFailMessage = ref('')
    const { app } = useContext()
    const formEl = ref<FormRef | null>(null)
    const submitText = ref('Verzenden')
    const formFields = reactive({
      email: '',
      firstName: '',
      lastName: ''
    })
    const rules: CustomRules<typeof formFields> = {
      // firstName: ['required'],
      // lastName: ['required'],
      email: ['required', 'email'],
    }
    const listId = ''
    const recaptchaResponse = ''
    const submitLoading = useLoading()
    
    const onSubmit = (e: Event) => {
      e.preventDefault()
      return submitLoading.scope(async () => {
        if (!formEl.value) return
        const valid = await formEl.value.validate()
        if (!valid) return
        const response = await app.$api.newsletter.submitForm(
            listId,
            formFields.email,
            formFields.firstName,
            formFields.lastName,
            recaptchaResponse
        )
        if (response && response.success === true) {
              window.location.href = 'aanmelden-bedankt'
            } else if (response && response.reasonCode == "AlreadyMember" ) {
              submitFailMessage.value = 'Dit adres is al aangemeld'
              isSubmitFail.value = !!submitFailMessage.value
            } else {
              submitFailMessage.value = 'Er ging iets mis. Probeer het nog eens.'
              isSubmitFail.value = !!submitFailMessage.value
        }
      })
    }

    


    return {
      formEl,
      submitLoading: submitLoading.value,
      submitFailMessage,
      isSubmitFail,
      onSubmit,
      submitText,
      emailCorrect,
      formFields,
      app,
      rules
    }
  }
})
